import React, { useEffect, useState } from 'react';
import {
    Grid,
    Box,
    Typography,
    Divider,
} from '@mui/material';
import { CloseIcon } from '../../../assets';
import { CustomReactSelect, CustomButton } from '../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedCampaignPartners } from '../../../redux/thunks/campaignThunks'
import { actions } from '../../../redux/reducers/dataSourcesReducer';
import { createDataSources } from '../../../redux/thunks/dataSourcesThunk';
import { useForm, useController } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { selectCampaignPartnerOptions } from '../../../redux/reducers/campaignReducer';
import { validateForScriptTag } from '../../../utility';

const initialValue =  {
    name: "",
    partner: "",
};

const dataSources = yup.object({
    name: yup.string().required('The name field is required.').test('no-script-tag', 'Script tags are not allowed.',validateForScriptTag),
    partner: yup.string().required('The partner id field is required.'),
}).required();

function CreateDataSource(props) {
    const { handleClose } = props;
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { isNewTrigger } = useSelector(state => state.dataSources);
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({ resolver: yupResolver(dataSources), defaultValues: initialValue });
    const campaignPartners = useSelector(selectCampaignPartnerOptions());
    const handlePartner = (option) => {
        setValue('partner', option.value)
    }

    useEffect(() => {
        if(company.id){
            dispatch(getSelectedCampaignPartners({ companyId: company.id }));
        }
    }, [company.id, dispatch])

    const onSubmit = (data) =>{
        dispatch(createDataSources({companyId: company.id, data: {
            fields: [],
            name:data.name,
            partner_id: data.partner
        }})).then(result=>{
            dispatch(actions.handleEditOpen())
            dispatch(actions.handleNew(isNewTrigger))
        })
        
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} data-testid="data_source_create_new">
        <Grid
            container
            className='modal_main'
        >
           
                <Grid item xs={12}>
                    <Box className="padding-24px">
                        {/* Create data source */}
                        <Box className="flex-row-space-between pb-24px" >
                            <Typography className='text-500fw-18fs-28lh'>
                                Create data source
                            </Typography>
                            <Box className='cursor-pointer' onClick={handleClose}>
                                <CloseIcon color="#98A2B3" width='12' height='12' />
                            </Box>
                        </Box>

                        {/* Data Source Name */}
                        <Box className="flex-column gap-6 pb-24px w-100">
                            <Typography className='metrics-dropdown-title' >
                                Data Source Name
                            </Typography>
                            <input
                                type="text"
                                placeholder='Data Source Name'
                                className='query_name-input-field'
                                {...register('name')}
                                data-testid="ds_name-input-field"
                            />
                             <span className="text-xs-regular error-500" data-testid="error-message">
                                    {errors.name?.message}
                                </span>
                        </Box>

                        {/* Partner */}
                        <Box data-testid="partner_dropdown_box">
                            <CustomReactSelect
                                label='Partner'
                                isOptionsSearchable={true}
                                options={campaignPartners}
                                handleFilter={handlePartner}
                                placeholder='Select Partner'
                                {...register('partner')}
                                data_test_id="partner-dropdown"
                            />
                             <span className="text-xs-regular error-500" data-testid="error-message">
                                    {errors.partner?.message}
                                </span>
                        </Box>
                    </Box>
                </Grid>

                <Grid
                    item
                    xs={12}
                    className='flex-1-mt-auto'
                    
                >
                    <Divider  className='border-1-gray' />
                    <Box className='flex-row-end-center gap-12 padding-tb-16-rl-24'>
                        <CustomButton
                            title="Cancel"
                            handleClick={handleClose}
                            data_test_id="cancel-button"
                        />
                        <CustomButton
                            title="Save"
                            titleColor="#FFFFFF"
                            buttonColor="#AD509E"
                            type="submit"
                            data_test_id="ds_create_button"
                        />
                    </Box>
                </Grid>
       
        </Grid>
        </form>

    )
}

export default CreateDataSource;